var _rect, _circle, _circle2, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIc3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "#C0DCFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 26,
    fill: "white",
    stroke: "#288BFF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 21,
    fill: "white",
    stroke: "#288BFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5872 48H37.1277L39.1596 40.0865C39.4607 38.8324 39.7115 37.6 39.9624 36.3892H40.0627C40.2885 37.6 40.5644 38.8324 40.8654 40.0865L42.9475 48H47.5633L51 32H47.4629L46.008 39.8054C45.732 41.4703 45.4561 43.1784 45.1802 44.9081H45.0547C44.6534 43.1784 44.2771 41.4486 43.8757 39.8054L41.7184 32H38.5576L36.4002 39.8054C35.9989 41.4703 35.5975 43.2 35.2212 44.9081H35.1209C34.8449 43.2 34.5439 41.4919 34.268 39.8054L32.7879 32H29L32.5872 48Z",
    fill: "#288BFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 38,
    width: 26,
    height: 3,
    fill: "#288BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc3);
export default __webpack_public_path__ + "static/media/ic_3.baff6a07f05f203873f63aba4f28769d.svg";
export { ForwardRef as ReactComponent };